module.exports = __webpack_public_path__ + "img/hc-cooling-loads.f0ecaf1a.png";